import styled, { css } from 'styled-components';
import { ApMenu, colors } from '@alixpartners/ui-components';

export const StyledMenu = styled(ApMenu)`
	padding-bottom: 0 !important;
	overflow: hidden !important;
	display: flex;
	flex-direction: column;
	max-width: 300px !important;
	width: 300px !important;
	max-height: calc(100% - 102px) !important;

	${({ isFullHeight }) =>
		isFullHeight &&
		css`
			height: 100%;
		`};
`;

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	max-height: 100%;
	height: 100%;
	overflow: auto;
`;

export const OptionWrapper = styled.div`
	display: flex;
	width: 100%;
	padding: 0 6px;
	cursor: default;
	justify-content: space-between;
	overflow: hidden;
`;

export const OptionLabel = styled.div`
	font-size: 16px;
	color: ${colors.grey8};
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;
`;

export const OptionInfo = styled.div`
	font-size: 13px;
	line-height: 16px;
	color: ${colors.grey5};
	letter-spacing: 0.3px;
	padding-left: 8px;
	display: flex;
	align-items: center;
	white-space: nowrap;
`;
